<template>
  <div class="main">
    <el-upload
      action="#"
      list-type="picture-card"
      :http-request="upload"
      :on-success="uploadSuccess"
      :file-list="fileList"
    >
      <i class="el-icon-plus"></i>
      <span class="upload-text">{{data.name}}</span>
      <div slot="file" slot-scope="{file}">
        <span class="file-tag">{{data.name}}</span>
        <img class="el-upload-list__item-thumbnail" :src="file.url" />
        <span class="el-upload-list__item-actions" v-if="!data.disabled">
          <span class="el-upload-list__item-preview" @click="handlePreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="handleRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible" class="center">
      <img width="100%" :src="dialogImageUrl" />
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: "data"
  },
  props: {
    data: Object
  },
  data() {
    return {
      fileList: [],
      dialogImageUrl: "",
      dialogVisible: false
    };
  },
  methods: {
    upload(file) {
      file.onSuccess();
    },
    uploadSuccess(res, file, fileList) {
      this.fileList = fileList;
      this.data.file = file.raw;
      this.$emit("update:data", this.data);
    },
    handleRemove(file) {
      this.fileList = [];
      if (this.data.file) {
        delete this.data.file;
      }
      this.$emit("update:data", this.data);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    }
  },
  mounted() {
    if (this.data.file) {
      this.fileList = [this.data.file];
    }
  }
};
</script>

<style lang="less" scoped>
.main {
  margin-top: 20px;
  margin-right: 35px;
  width: 148px;
  height: 148px;
  overflow: hidden;

  &:nth-of-type(5n) {
    margin-right: 0;
  }

  .file-tag {
    background-color: #f5a702;
    color: #fff;
    font-size: 14px;
    position: absolute;
    padding: 0 10px;
    border-radius: 4px 0 8px;
  }
  /deep/ .el-upload--picture-card {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;

    .upload-text {
      line-height: 1;
      color: #999;
      margin-top: 10px;
    }
  }

  // 图片居中显示
  /deep/ .el-upload-list__item {
    div {
      width: 100%;
      height: 100%;
      display: flex;

      img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        margin: auto;
      }
    }
  }
  .center {
    display: flex;

    /deep/ .el-dialog {
      margin: auto !important;
    }
  }
}
</style>